import { Component } from "@angular/core";

@Component({
  selector: "hcp-page",
  templateUrl: "hcp.page.html"
})
export class HcpPage {
  constructor(
  ) {
    // No empty block
  }

}



// WEBPACK FOOTER //
// ./src/pages/hcp.page/hcp.page.ts